<script>
import { dashboardReportsMixins } from "../../mixins/dashboardReportsMixins";
import { Line, mixins } from "vue-chartjs";
import i18n from "../../i18n";

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
  },
  created() {
    this.fetchChartData();
    this.options.title.text = this.chartdata.graphTitle;
  },
  data() {
    return {
      statsCardUIElements: {},
      options: {
        title: {
          display: true,
          text: "Reports",
          color: "black",
          fontSize: 20, // Title font size
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
              afterDataLimits(scale) {
                scale.max += 1;
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        layout: {
          padding: {
            bottom: 40, // Space below the graph
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    async fetchChartData() {
      this.statsCardUIElements = await this.reportsCardsUIElements();

      let chartDataPoints = {
        labels: this.chartdata.SEARCH_RECORD.xPoints,
        datasets: [
          {
            label: i18n.t("customer.reports.graphDataPoints.searchTitle"),
            data: this.chartdata.SEARCH_RECORD.yPoints,
            fill: false,
            borderColor: this.statsCardUIElements.search.color,
            backgroundColor: this.statsCardUIElements.search.color,
            borderWidth: 2,
          },
          {
            label: i18n.t("customer.reports.graphDataPoints.createTitle"),
            data: this.chartdata.CREATE_RECORD.yPoints,
            fill: false,
            borderColor: this.statsCardUIElements.create.color,
            backgroundColor: this.statsCardUIElements.create.color,
            borderWidth: 2,
          },
          {
            label: i18n.t("customer.reports.graphDataPoints.updateTitle"),
            data: this.chartdata.UPDATE_RECORD.yPoints,
            fill: false,
            borderColor: this.statsCardUIElements.update.color,
            backgroundColor: this.statsCardUIElements.update.color,
            borderWidth: 2,
          },
          {
            label: i18n.t(
              "customer.reports.graphDataPoints.linkTranscriptTitle"
            ),
            data: this.chartdata.LINKTRANSCRIPT_RECORD.yPoints,
            fill: false,
            borderColor: this.statsCardUIElements.link.color,
            backgroundColor: this.statsCardUIElements.link.color,
            borderWidth: 2,
          },
          {
            label: i18n.t("customer.reports.graphDataPoints.loginsTitle"),
            data: this.chartdata.LOGIN_RECORD.yPoints,
            fill: false,
            borderColor: this.statsCardUIElements.login.color,
            backgroundColor: this.statsCardUIElements.login.color,
            borderWidth: 2,
          },
        ],
      };

      this.renderChart(chartDataPoints, this.options);
    },
  },
  mixins: [mixins.reactiveProp, dashboardReportsMixins],
};
</script>